/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormUbahJadwalKelas from '../components/FormUbahJadwalKelas'

import getJadwalKelasData from '../services/getJadwalKelasData'
import getRuangan from '../services/getRuangan'
import getHari from '../services/getHari'
const UbahJadwalKelasPage = props => {
const { id, kelasId } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	ubahJadwalKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [jadwalKelasData, setJadwalKelasData] = useState()
const [ruangan, setRuangan] = useState()
const [hari, setHari] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, ubahJadwalKelas: true}))
		const { data: jadwalKelasDataResponse } = await getJadwalKelasData({ id  })
		const { data: ruanganResponse } = await getRuangan({ id  })
		const { data: hariResponse } = await getHari({ id  })

	    setJadwalKelasData(jadwalKelasDataResponse.data)
	    setRuangan(ruanganResponse.data)
	    setHari(hariResponse.data)


	    setIsLoading(prev => ({...prev, ubahJadwalKelas: false}))
    }
	if (checkPermission("UpdateJadwalKelas")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Ubah Jadwal Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas/${kelasId}
			  	`}>
			  		<Button id="_6s5YYC1fEfCiIOe1nt4Q7w" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("UpdateJadwalKelas") && ( 
	<Layouts.FormContainerLayout
		singularName={"Jadwal"}
		isLoading={isLoading.ubahJadwalKelas}
	>
		{jadwalKelasData && ruangan && hari ? 
		(<>
		 <FormUbahJadwalKelas
			{...{ 
				jadwalKelasData
, 				ruangan
, 				hari
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default UbahJadwalKelasPage

